import { render, staticRenderFns } from "./CompleteRevisionDialogCpt.vue?vue&type=template&id=8736da50&scoped=true&"
import script from "./CompleteRevisionDialogCpt.vue?vue&type=script&lang=ts&"
export * from "./CompleteRevisionDialogCpt.vue?vue&type=script&lang=ts&"
import style0 from "./CompleteRevisionDialogCpt.vue?vue&type=style&index=0&id=8736da50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8736da50",
  null
  
)

export default component.exports